import React, { useState } from 'react';
import ChatHistory from './ChatHistoryPage';
import NewChat from './NewChatPage';
// import ImageToDesciption from './ImageToDescriptionPage';
// import ImageToVideo from './ImageToVideo';
// import AudioToText from './AudioToText';
// import Enterprize from './EnterPrise';
import Chatpage from './ChatPage';

const SwitchTab = () => {
  const [activeTab, setActiveTab] = useState('new');

  return (
    <div>
      {/* Top Tab Switch */}
      <div className="d-flex  border-bottom px-3 py-2" style={{backgroundColor:"white"}}>
        <button
          className={`btn btn-link me-2 ${activeTab === 'new' ? 'text-dark fw-bold' : 'text-muted text-decoration-none'}`}
          onClick={() => setActiveTab('new')}
        >
          New Chat
        </button>
        <button
          className={`btn btn-link ${activeTab === 'history' ? 'text-dark fw-bold' : 'text-muted text-decoration-none'}`}
          onClick={() => setActiveTab('history')}
        >
          Chat History
        </button>
      </div>

      {/* Page Content */}
      <div>
        {activeTab === 'new' ? <Chatpage /> : <ChatHistory />}
      </div>
    </div>
  );
};

export default SwitchTab;
